import GeneralService from "./GeneralService";


export class TestRunService  {
    public static createTestRun(payload: any, loadingHandler: any, apiKey: string) {
        return GeneralService.post("/test_runs/", JSON.stringify(payload), loadingHandler, JSON, GeneralService.PROD_ENDPOINT, apiKey);
    }

    public static deleteTestRun(testRunId: number, loadingHandler: any, apiKey: string) {
        return GeneralService.delete(`/test_runs/${testRunId}`, JSON.stringify({}), loadingHandler, JSON, GeneralService.PROD_ENDPOINT, apiKey);
    }

    public static getTestRun(testRunId: number, loadingHandler: any, apiKey: string) {
        return GeneralService.get(`/test_runs/${testRunId}`, loadingHandler, JSON, GeneralService.PROD_ENDPOINT, apiKey);
    }

    public static getTestRunsByTestSet(testSetId: number, offset: number, limit: number, loadingHandler: any, apiKey: string) {
        return GeneralService.get(`/test_runs/test_set/${testSetId}/${offset}/${limit}`, loadingHandler, JSON, GeneralService.PROD_ENDPOINT, apiKey);
    }

    public static getTestRunsByApplicationAction(applicationId: number, actionId: number, offset: number, limit: number, loadingHandler: any, apiKey: string) {
        return GeneralService.get(`/test_runs/application/${applicationId}/action/${actionId}/${offset}/${limit}`, loadingHandler, JSON, GeneralService.PROD_ENDPOINT, apiKey);
    }

    public static getTestRunRequests(testRunId: number, offset: number, limit: number, loadingHandler: any, apiKey: string, selectedScores: number[] | null) {
        return GeneralService.post(
            `/test_runs/${testRunId}/requests/${offset}/${limit}`,
            JSON.stringify({ scores: selectedScores }),
            loadingHandler,
            JSON,
            GeneralService.PROD_ENDPOINT,
            apiKey
        );
    }

    public static getTestRunResults(testRunId: number, loadingHandler: any, apiKey: string) {
        return GeneralService.get(`/test_runs/${testRunId}/results`, loadingHandler, JSON, GeneralService.PROD_ENDPOINT, apiKey);
    }

    public static getTestRunProgress(testRunId: number, loadingHandler: any, apiKey: string) {
        return GeneralService.get(`/test_runs/${testRunId}/progress`, loadingHandler, JSON, GeneralService.PROD_ENDPOINT, apiKey);
    }

    public static getTestRunProgressByTestSet(testSetId: number, loadingHandler: any, apiKey: string) {
        return GeneralService.get(`/test_runs/test_set/${testSetId}/progress`, loadingHandler, JSON, GeneralService.PROD_ENDPOINT, apiKey);
    }

    public static getTestRunRequestComparison(testRunId: number, testRunRequestId: number, offset: number, limit: number, loadingHandler: any, apiKey: string) {
        return GeneralService.get(`/test_runs/${testRunId}/requests/${testRunRequestId}/compare/${offset}/${limit}`, loadingHandler, JSON, GeneralService.PROD_ENDPOINT, apiKey);
    }

    public static getTestRunsComparison(testRunIds: number[], offset: number, limit: number, loadingHandler: any, apiKey: string) {
        return GeneralService.post(
            `/test_runs/compare/${offset}/${limit}`,
            JSON.stringify({ 
                test_run_ids: testRunIds
            }),
            loadingHandler,
            JSON,
            GeneralService.PROD_ENDPOINT,
            apiKey
        );
    }
}